export default {
  entity: {
    id: null,
    name: 'Kenny',
    lastName: 'Mochizuki',
    token: '',
    loaded: false,
    email: ''
  },

  list: []
}